import { useState } from 'react';
import { Send, X, Lock, Globe } from 'lucide-react';

interface CommentReplyFormProps {
  onSubmit: (content: string, isPrivate: boolean) => void;
  onCancel: () => void;
  placeholder?: string;
}

export default function CommentReplyForm({
  onSubmit,
  onCancel,
  placeholder = '답글을 작성하세요...',
}: CommentReplyFormProps) {
  const [content, setContent] = useState('');
  const [isPrivate, setIsPrivate] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!content.trim()) {
      return;
    }

    onSubmit(content.trim(), isPrivate);
    setContent('');
    setIsPrivate(false);
  };

  return (
    <form onSubmit={handleSubmit} className="bg-gray-50 rounded-lg border border-gray-200 p-3">
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder={placeholder}
        rows={3}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary resize-none text-sm bg-white"
        autoFocus
      />

      <div className="mt-2 flex items-center justify-between">
        {/* 비공개 토글 */}
        <button
          type="button"
          onClick={() => setIsPrivate(!isPrivate)}
          className={`flex items-center gap-1.5 px-2.5 py-1 rounded text-xs font-medium transition-colors ${
            isPrivate
              ? 'bg-white text-gray-700 border border-gray-300'
              : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
          }`}
        >
          {isPrivate ? (
            <>
              <Lock className="w-3 h-3" />
              비공개
            </>
          ) : (
            <>
              <Globe className="w-3 h-3" />
              공개
            </>
          )}
        </button>

        {/* 버튼 */}
        <div className="flex gap-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-3 py-1.5 bg-white text-gray-600 rounded hover:bg-gray-100 transition-colors text-xs font-medium flex items-center gap-1 border border-gray-200"
          >
            <X className="w-3 h-3" />
            취소
          </button>
          <button
            type="submit"
            disabled={!content.trim()}
            className="px-3 py-1.5 bg-primary text-white rounded hover:bg-primary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1 text-xs font-medium"
          >
            <Send className="w-3 h-3" />
            답글 작성
          </button>
        </div>
      </div>
    </form>
  );
}
